import { createContext, useContext } from 'react'

// Whether what's drawn here sits in the phone's top bar (nav/BarRow), so it can drop the page's own side padding.
export const InBar = createContext(false)
export const useInBar = () => useContext(InBar)
